// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: open the Assistant DM, optionally sending a first prompt — used by
// the Claude connect flow's "try it" chips and the Today page card.

import * as PrivateChannelCommands from '@app/features/channel/commands/PrivateChannelCommands';
import * as MessageCommands from '@app/features/messaging/commands/MessageCommands';
import * as NavigationCommands from '@app/features/navigation/commands/NavigationCommands';
import {KONVOBOT_ID, ME} from '@konvo/constants/src/AppConstants';
import * as SnowflakeUtils from '@konvo/snowflake/src/SnowflakeUtils';

export async function openKonvoAssistant(prompt?: string): Promise<void> {
	const channel = await PrivateChannelCommands.ensureDMChannelResponse(KONVOBOT_ID);
	NavigationCommands.selectChannel(ME, channel.id);
	if (prompt?.trim()) {
		await MessageCommands.send(channel.id, {content: prompt.trim(), nonce: SnowflakeUtils.fromTimestamp(Date.now())});
	}
}

/** Sends a prompt to the Assistant DM without leaving the current chat; the reply arrives as a normal DM notification. */
export async function sendToKonvoAssistant(prompt: string): Promise<void> {
	if (!prompt.trim()) return;
	const channel = await PrivateChannelCommands.ensureDMChannelResponse(KONVOBOT_ID);
	await MessageCommands.send(channel.id, {content: prompt.trim(), nonce: SnowflakeUtils.fromTimestamp(Date.now())});
}
